import { Dialog } from "primereact/dialog";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import { JVInput } from "../../../shared/JVInput";
import { JVDropdown } from "../../../shared/JVDropdown";
import { baseUrl, Fetch } from "../../../shared/Fetch";
import { ITopic } from "../trainingMasters/trainingTopics/Table";
import { ICategory } from "../trainingMasters/trainingCategory/Table";
import { FileUpload, FileUploadHandlerParam } from "primereact/fileupload";
import { ITrainingForm } from "./Table";

interface IProps {
    open: boolean,
    singleData: ITrainingForm,
    hideDialog: () => void,
    toast: any,
    reloadTable: () => void,
}

interface ISubmissionForm {
    category_ID?: number,
    topic_ID?: number,
}

const schema = yup.object({
    category_ID: yup.number().required("Category is required*"),
    topic_ID: yup.number().required("Topic is required*")
});

export const Form = (props: IProps) => {
    const [allTopics, setAllTopics] = useState<Array<ITopic>>([]);
    const [allCategory, setAllCategory] = useState<Array<ICategory>>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [shwTopics, setShwTopics] = useState<boolean>(true);
    const [userManual, setUserManual] = useState<boolean>(false);
    const [userManualFile, setUserManualFile] = useState<File | null | any>(null);
    const [document, setDocument] = useState<boolean>(false);
    const [documentFile, setDocumentFile] = useState<File | null | any>(null);
    const { control, handleSubmit, formState: { errors }, reset, watch } = useForm<ISubmissionForm>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });

    const userManualUploade = (event: FileUploadHandlerParam) => {
        const file = event.files[0];
        if (event.files[0].size > 1024 * 1024 * 2) {
            props.toast.current.show({ severity: 'error', content: "File should be less than 2 MB." });
            event.options.clear();
        } else {
            setUserManual(true);
            setUserManualFile(file);
            props.toast.current.show({ severity: 'success', summary: 'Success', detail: "User Manual Selecetd", life: 3000 });
            event.options.clear();
        }

        // if (event.files[0].type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
        //     if (event.files[0].size > 1024 * 1024 * 2) {
        //         props.toast.current.show({ severity: 'error', content: "DOCX File should be less than 2 MB." });
        //         event.options.clear();
        //     } else {
        //         setUserManual(true);
        //         setUserManualFile(file);
        //         props.toast.current.show({ severity: 'success', summary: 'Success', detail: "Resume Selecetd", life: 3000 });
        //         event.options.clear();
        //     }
        // } else {
        //     props.toast.current.show({ severity: 'error', content: "Please Choose A DOCX File." });
        //     event.options.clear();
        // }
    };

    const documentUploade = (event: FileUploadHandlerParam) => {
        const file = event.files[0];
        if (event.files[0].size > 1024 * 1024 * 2) {
            props.toast.current.show({ severity: 'error', content: "File should be less than 2 MB." });
            event.options.clear();
        } else {
            setDocument(true);
            setDocumentFile(file);
            props.toast.current.show({ severity: 'success', summary: 'Success', detail: "Document Selecetd", life: 3000 });
            event.options.clear();
        }
    };

    const loadTopics = async (category_ID: number) => {
        const res = await Fetch("CarnivalTraining/getActiveTopics", "GET", null, category_ID != 0 ? `category_ID=${category_ID}` : null, props.toast);
        if (res) {
            const data: ITopic[] = await res.json();
            setAllTopics(data);
        }
    };

    const loadCategories = async () => {
        const res = await Fetch("CarnivalTraining/getActiveCategory", "GET", null, null, props.toast);
        if (res) {
            const data: ICategory[] = await res.json();
            setAllCategory(data);
        }
    };

    const onHide = () => {
        setUserManualFile(null);
        setUserManual(false);
        setDocumentFile(null);
        setDocument(false);
        setLoading(false);
        setShwTopics(true);
        props.reloadTable();
        props.hideDialog();
    }

    const onSubmit = async (body: ISubmissionForm) => {
        if (!props.singleData?.form_ID && userManual === false && document === false) {
            props.toast.current.show({ severity: 'error', content: "Please Select User Manual & Supportive Document File" });
        } else if (!props.singleData?.form_ID && userManual === false && document === true) {
            props.toast.current.show({ severity: 'error', content: "Please Select User Manual File" });
        } else if (!props.singleData?.form_ID && userManual === true && document === false) {
            props.toast.current.show({ severity: 'error', content: "Please Select Supportive Document File" });
        } else {
            setLoading(true);
            let formBody: any = body;
            const method: string = props.singleData.form_ID ? "PUT" : "POST";
            const message: string = props.singleData.form_ID ? "Updated Successfully" : "Added Successfully";
            const url: string = props.singleData.form_ID ? "updateTrainerSubmissionForm" : "addTrainerSubmissionForm";

            if (props.singleData.form_ID) {
                formBody.form_ID = props.singleData.form_ID;
                formBody.topic_ID = body.topic_ID;
                formBody.category_ID = body.category_ID;
            }

            const formData = new FormData();
            formData.append('userManual', userManualFile);
            formData.append('document', documentFile);
            formData.append('data', JSON.stringify(formBody));
            const params = {
                method: method,
                headers: {
                    'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
                },
                body: formData
            };

            const response = await fetch(`${baseUrl}CarnivalTraining/${url}`, params);

            if (response.status === 400) {
                const message1 = await response.text();
                props.toast.current.show({ severity: 'error', detail: message1, life: 3000 });
                setLoading(false);
            }
            if (response.ok) {
                props.toast.current.show({ severity: 'success', content: message });
                setLoading(false);
                onHide();
            } else setLoading(false);
        }
    }

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "category_ID") {
                if (value.category_ID != 0 && value.category_ID != null) {
                    loadTopics(value.category_ID);
                    setShwTopics(false);
                } else {
                    loadTopics(0);
                    setShwTopics(true);
                }
            }
        });

        return () => subscription.unsubscribe();
    }, [watch, shwTopics]);

    useEffect(() => {
        if (props.open) {
            loadCategories();
            reset(props.singleData);
            if (props.singleData.form_ID) {
                loadTopics(props.singleData.category_ID || 0);
                setShwTopics(false);
            }
        }
    }, [props.open]);

    return (
        <Dialog visible={props.open} style={{ width: '60vw' }} header="Add/Edit Submission" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVDropdown required label="Category" control={control} name="category_ID" options={allCategory} optionLabel="category_Name" optionValue="category_ID" placeholder="Select Category" error={errors.category_ID?.message} />
                <JVDropdown disabled={shwTopics} required label="Topic" control={control} name="topic_ID" options={allTopics} optionLabel="topic_Name" optionValue="topic_ID" placeholder="Select Topic" error={errors.topic_ID?.message} />
                <div className="field col-12 md:col-6">
                    <p>Choose User Manual{!props.singleData?.form_ID && <span style={{ color: 'red' }}>*</span>}</p>
                    <FileUpload chooseLabel={userManual === false ? "Choose File" : "File Selected"} mode="basic" name="resume" accept=".*" auto customUpload uploadHandler={userManualUploade} />
                </div>
                <div className="field col-12 md:col-6">
                    <p>Choose Supportive Document{!props.singleData?.form_ID && <span style={{ color: 'red' }}>*</span>}</p>
                    <FileUpload chooseLabel={document === false ? "Choose File" : "File Selected"} mode="basic" name="resume" accept=".*" auto customUpload uploadHandler={documentUploade} />
                </div>
                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button style={{ width: '100px' }} label="SAVE" type="submit" loading={loading} disabled={loading}></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-outlined surface-200"></Button>
                </div>
            </form>
        </Dialog>
    );
}